import { InjectionToken } from '@angular/core';

export const CONNECT_API_URL = new InjectionToken<string>('CONNECT_API_URL');
